module.exports = __webpack_public_path__ + "static/img/2.345137e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/2.jpg
// module id = ZzQq
// module chunks = 5